export const meta = {
    keyExpr: 'kod_direct',
    sort: {
        type: 'desc',
        field: 'name',
    },
    columns: [
        {
            name: 'kod_direct',
            caption: 'ID',
            dataField: 'kod_direct',
            allowEditing: false,
            width: 250,
            index: 2,
            visible: false,
        },
        {
            name: 'name',
            caption: 'Наименование',
            dataField: 'name',
            allowEditing: true,
            index: 1,
            width: 350,
            visible: true,
        },
        {
            name: 'name_kr',
            caption: 'Краткое наименование',
            dataField: 'name_kr',
            allowEditing: true,
            index: 4,
            visible: true,
        },
        {
            name: 'kod_predpr',
            caption: 'Код подразделения',
            dataField: 'kod_predpr',
            allowEditing: true,
            index: 3,
            width: 200,
            visible: true,
        },
        {
            name: 'kod_subj',
            caption: 'Код субъекта РФ',
            dataField: 'kod_subj',
            editor: {
                type: 'ai-drop-down',
                text: 'kod_subj',
            },
            component: {
                name: 'spr-fed-subject-lookup-view',
                id: 'kod_subj',
                text: 'kod_subj',
            },
            visible: true,
            allowEditing: true,
            dataType: 'string',
        },
        {
            name: 'kod_podr',
            caption: ' Группа подразделений',
            dataField: 'kod_podr',
            allowEditing: true,
            width: 250,
            index: 9,
            visible: true,
            editor: {
                type: 'ai-drop-down',
                text: 'podr_name',
            },
            component: {
                name: 'posprpodr-lookup-view',
                id: 'kod_podr',
                text: 'name',
            },
        },
        {
            name: 'kod_spr_doc',
            caption: 'Вид подразделения',
            dataField: 'kod_spr_doc',
            allowEditing: true,
            width: 250,
            index: 17,
            visible: true,
            editor: {
                type: 'ai-drop-down',
                text: 'doc_name',
            },
            component: {
                name: 'issprdoc-lookup-view',
                id: 'kod_spr_doc',
                text: 'name',
            },
        },
        {
            name: 'mvp_code',
            caption: 'Код МВП (фин.сист.)',
            dataField: 'mvp_code',
            allowEditing: true,
            index: 34,
            visible: true,
        },
        {
            name: 'mvp_name',
            caption: 'Наименование МВП (фин.сист.)',
            dataField: 'mvp_name',
            allowEditing: true,
            index: 35,
            visible: true,
        },
        {
            name: 'mb3_code',
            caption: 'Маска кода МВЗ (фин.сист.)',
            dataField: 'mb3_code',
            allowEditing: true,
            index: 36,
            visible: true,
        },
        {
            name: 'kod_spr_group',
            caption: 'Код группировки',
            dataField: 'kod_spr_group',
            allowEditing: true,
            index: 37,
            visible: true,
            editor: {
                type: 'ai-drop-down',
                text: 'gr_name',
            },
            component: {
                name: 'grouping-lookup-view',
                id: 'kod_spr_group',
                text: 'gr_name',
            },
        },
        {
            name: 'use_in_mped',
            caption: ' Показывать МПЭД',
            dataField: 'use_in_mped',
            allowEditing: true,
            dataType: 'boolean',
            width: 250,
            index: 38,
            visible: true,
        },
        {
            name: 'path_doc',
            caption: 'Путь хранения док-тов',
            dataField: 'path_doc',
            allowEditing: true,
            width: 250,
            index: 20,
            visible: false,
        },
        {
            name: 'god',
            caption: 'Год окончания действия',
            dataField: 'god',
            allowEditing: true,
            width: 250,
            index: 7,
            visible: false,
        },
        {
            name: 'mes',
            caption: 'Месяц окончания действия',
            dataField: 'mes',
            allowEditing: true,
            width: 250,
            index: 6,
            visible: false,
        },
        {
            name: 'd_c',
            caption: 'дата создания',
            dataField: 'd_c',
            allowEditing: false,
            width: 250,
            index: 46,
            visible: false,
        },
        {
            name: 'u_c',
            caption: 'пользователь создатель ',
            dataField: 'u_c',
            allowEditing: false,
            width: 250,
            index: 43,
            visible: false,
        },
        {
            name: 'd_m',
            caption: 'дата модификации',
            dataField: 'd_m',
            allowEditing: false,
            width: 250,
            index: 42,
            visible: false,
        },
        {
            name: 'u_m',
            caption: 'пользователь последний изменивший',
            dataField: 'u_m',
            allowEditing: false,
            width: 250,
            index: 44,
            visible: false,
        },
        {
            name: 'kod_parent',
            caption: 'kod_parent',
            dataField: 'kod_parent',
            allowEditing: false,
            width: 250,
            index: 5,
            visible: false,
        },
        {
            name: 'en_gor',
            caption: 'en_gor',
            dataField: 'en_gor',
            allowEditing: false,
            width: 250,
            index: 10,
            visible: false,
        },
        {
            name: 'en_obl',
            caption: 'en_obl',
            dataField: 'en_obl',
            allowEditing: false,
            width: 250,
            index: 11,
            visible: false,
        },
        {
            name: 'tep_gor',
            caption: 'tep_gor',
            dataField: 'tep_gor',
            allowEditing: false,
            width: 250,
            index: 12,
            visible: false,
        },
        {
            name: 'kod_plant',
            caption: 'kod_plant',
            dataField: 'kod_plant',
            allowEditing: false,
            width: 250,
            index: 13,
            visible: false,
        },
        {
            name: 'tep_obl',
            caption: 'tep_obl',
            dataField: 'tep_obl',
            allowEditing: false,
            width: 250,
            index: 14,
            visible: false,
        },
        {
            name: 'prizn_isp',
            caption: 'prizn_isp',
            dataField: 'prizn_isp',
            allowEditing: false,
            width: 250,
            index: 15,
            visible: false,
        },
        {
            name: 'crkp',
            caption: 'crkp',
            dataField: 'crkp',
            allowEditing: false,
            width: 250,
            index: 16,
            visible: false,
        },

        {
            name: 'kod_dir_old',
            caption: 'kod_dir_old',
            dataField: 'kod_dir_old',
            allowEditing: false,
            width: 250,
            index: 18,
            visible: false,
        },
        {
            name: 'kod_gkpz',
            caption: 'kod_gkpz',
            dataField: 'kod_gkpz',
            allowEditing: false,
            width: 250,
            index: 19,
            visible: false,
        },

        {
            name: 'kod_kazn',
            caption: 'kod_kazn',
            dataField: 'kod_kazn',
            allowEditing: false,
            width: 250,
            index: 21,
            visible: false,
        },
        {
            name: 'kod_nemo',
            caption: 'kod_nemo',
            dataField: 'kod_nemo',
            allowEditing: false,
            width: 250,
            index: 22,
            visible: false,
        },
        {
            name: 'fl_branch',
            caption: 'fl_branch',
            dataField: 'fl_branch',
            allowEditing: false,
            width: 250,
            index: 23,
            visible: false,
        },
        {
            name: 'kod_xml_plan',
            caption: 'kod_xml_plan',
            dataField: 'kod_xml_plan',
            allowEditing: false,
            width: 250,
            index: 24,
            visible: false,
        },
        {
            name: 'invest_pr',
            caption: 'invest_pr',
            dataField: 'invest_pr',
            allowEditing: false,
            width: 250,
            index: 25,
            visible: false,
        },
        {
            name: 'fl_ask_atp',
            caption: 'fl_ask_atp',
            dataField: 'fl_ask_atp',
            allowEditing: false,
            width: 250,
            index: 26,
            visible: false,
        },
        {
            name: 'full_name',
            caption: 'full_name',
            dataField: 'full_name',
            allowEditing: false,
            width: 250,
            index: 30,
            visible: false,
        },
        {
            name: 'pr_vks_ofz',
            caption: 'pr_vks_ofz',
            dataField: 'pr_vks_ofz',
            allowEditing: false,
            width: 250,
            index: 31,
            visible: false,
        },
        {
            name: 'zone',
            caption: 'zone',
            dataField: 'zone',
            allowEditing: false,
            index: 32,
            visible: false,
        },
        {
            name: 'kodp',
            caption: 'kodp',
            dataField: 'kodp',
            allowEditing: false,
            width: 250,
            index: 33,
            visible: false,
        },
        {
            name: 'name_folder_sap',
            caption: 'name_folder_sap',
            dataField: 'name_folder_sap',
            allowEditing: false,
            width: 250,
            index: 39,
            visible: false,
        },
        {
            name: 'adr',
            caption: 'adr',
            dataField: 'adr',
            allowEditing: false,
            width: 250,
            index: 40,
            visible: false,
        },
        {
            name: 'kod_caps',
            caption: 'kod_caps',
            dataField: 'kod_caps',
            allowEditing: false,
            width: 250,
            index: 41,
            visible: false,
        },
        {
            name: 'name_rosseti',
            caption: 'name_rosseti',
            dataField: 'name_rosseti',
            allowEditing: false,
            width: 250,
            index: 48,
            visible: false,
        },
    ],
    api: {
        select: 'mped./mped/is-spr-direct-select/get',
        save: 'mped./mped/is-spr-direct-save/set',
    },
    parentIdExpr: 'kod_parent',
    viewId: 'issprdirect-view',
    scrollingMode: 'batch',
    findTool: 'filter',
};
